import {styled} from '@/plugins/emotion'

export const NativeInput = styled('input')({
  display: 'none',
})
